import React, { useState, useEffect } from "react";
import Header from "./Header";
import DatePicker from "react-datepicker";
import Loader from "./Loader";
import "react-datepicker/dist/react-datepicker.css";
import { Modal, Button, Badge, Table, Form, Row, Col } from "react-bootstrap";
import "./Css/ViewMaintenance.css";
import userDum from "../assets/userDum.webp";
import { BiArrowBack } from "react-icons/bi";
import { FaRupeeSign, FaEye } from "react-icons/fa";
import {
  check_vaild_save,
  combiled_form_data,
  empty_form,
  formatDateStringdot,
  handleError,
  handleSuccess,
  handleSuccessSession,
} from "../CommonJquery/CommonJquery";
import {
  APL_LINK,
  server_post_data,
  get_maintainance_data,
  maintainance_car_data,
} from "../ServiceConnection/serviceconnection";
import { useParams } from "react-router-dom";
import { retrieveData } from "../LocalConnection/LocalConnection";
import MaintenaceDataModal from "./MaintenaceDataModal";

const ViewMaintenance = () => {
  const retrievedAdminId = retrieveData("admin_id");
  const { id } = useParams();
  const [showUpcomingModal, setShowUpcomingModal] = useState(false);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [checked, setChecked] = useState("");
  const [checked1, setChecked1] = useState("");
  const [checked2, setChecked2] = useState("");
  const [otherChecked, setOtherChecked] = useState(false);
  const [otherValue, setOtherValue] = useState("");
  const [otherValue1, setOtherValue1] = useState("");
  const [otherValue2, setOtherValue2] = useState("");
  const [otherValue3, setOtherValue3] = useState("");
  const [otherValue4, setOtherValue4] = useState("");
  const [startDateMaintance, setStartDateMaintance] = useState(null);
  const [cardata, setcardata] = useState([]);
  const [bookingdata, setbookingdata] = useState([]);
  const [maintainance, setmaintainance] = useState([]);
  const [payment, setpayment] = useState([]);
  const [imagelink, setimagelink] = useState([]);
  const [errors, seterrors] = useState("");
  const [selectedLight, setSelectedLight] = useState("");
  const [ids, setids] = useState(0);

  const [formState, setFormState] = useState({});
  const handleShowMainModal = () => {
    setShowUpcomingModal(!showUpcomingModal);
  };
  const handleCheckboxChangeother = (label) => {
    if (label === "Other") {
      setOtherChecked(!otherChecked);
      setChecked("");
    } else {
      setChecked(label);
      setOtherChecked(false);
    }
  };

  const handleCheckboxChangeother1 = (label) => {
    setChecked1(label);
    if (label !== "Other") {
      setOtherValue1(""); // Clear the input when "Other" is not selected
    }
  };
  const handleCheckboxChangeother2 = (label) => {
    setChecked2(label);
    if (label !== "Other") {
      setOtherValue2(""); // Clear the input when "Other" is not selected
    }
  };

  useEffect(() => {
    master_data_get();
  }, []);

  const master_data_get = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("booking_id", id);
    await server_post_data(get_maintainance_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setcardata(Response.data.message.car);
          setbookingdata(Response.data.message.booking_data);
          setmaintainance(Response.data.message.data);
          setpayment(Response.data.message.payment);
          setimagelink(APL_LINK + Response.data.message.image_link);
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const handleOtherInputChange = (e) => {
    setOtherValue(e.target.value);
  };
  const handleDateChange = (date) => {
    setStartDateMaintance(date);
  };
  const [selectedPerson, setSelectedPerson] = useState("");
  const [selectedPerson1, setSelectedPerson1] = useState("");

  const handleChange = (value) => {
    setSelectedPerson(value);
    if (value !== "Other") {
      setOtherValue(""); // Clear the input when selecting predefined options
    }
  };
  const handleChange1 = (value) => {
    setSelectedLight(value);
    if (value !== "Other") {
      setOtherValue(""); // Clear input when another option is selected
    }
  };
  const paymentData = [
    { id: 1, date: "01-01-2024", paymentMode: "Paytm", amount: 5000 },
    { id: 2, date: "15-02-2024", paymentMode: "Cash", amount: 3500 },
  ];
  const carDetails = {
    Name: "Harsj Rane",
    Pickup_Date: "12-03-2025",
    Contact_No: "123456890",
    Email: "harsh@triosoft.ai",
    Licence_No: "1111111",
  };

  const mainbtanance = [
    {
      id: 1,
      date: "01-01-2024",
      machenic: "Roberto",
    },
    {
      id: 2,
      date: "15-02-2024",
      machenic: "Dar",
    },
  ];
  const [damage, setDamage] = useState("");

  const [files, setFiles] = useState(null);

  const handleDamageChange = (event) => {
    setDamage(event.target.value);
    setFiles(null);
  };

  // Handle file input change
  const handleFileChange = (event) => {
    setFiles(event.target.files);
  };

  const handleUploadClick = () => {
    document.getElementById("fileInput").click();
  };
  const [currentStep, setCurrentStep] = useState(0);

  const handleNext = () => {
    if (currentStep < 7) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    let vaild_data = check_vaild_save(form_data);
    console.log(vaild_data);
    if (vaild_data) {
      setshowLoaderAdmin(true);
      let fd_from = combiled_form_data(form_data, null);
      fd_from.append("main_id", ids);
      fd_from.append("currentStep", currentStep);
      fd_from.append("booking_id", id);
      fd_from.append("user_id", retrievedAdminId);
      fd_from.append("car_id", cardata.primary_id);
      await server_post_data(url_for_save, fd_from)
        .then((Response) => {
          setshowLoaderAdmin(false);
          if (Response.data.error) {
            seterrors(Response.data.message);
            // handleError(Response.data.message);
          } else {
            
            if (ids === 0) {
              setids(Response.data.message.idsss);
            }
            if (currentStep < 7) {
              setCurrentStep(currentStep + 1);
            }
            if (currentStep === 7) {
              handleSuccess(Response.data.message);
              // empty_form(form_data);
              setShowUpcomingModal(!showUpcomingModal);
            }
          }
        })
        .catch((error) => {
          console.log(error);
          setshowLoaderAdmin(false);
        });
    }
  };

  return (
    <div>
      {showLoaderAdmin && <Loader />}
      <Header />
      <div className="container-lg">
        <div className="mainnveContrr">
          <div className="left_detail">
            <img src={imagelink + cardata["image"]} alt="userDum"></img>
            <div className="lefttextCar">
              <p className="card_Heading">{cardata["car_name"]}</p>
              <p className="cardText">
                {bookingdata["name"]},{" "}
                <span>Pickup Date : {bookingdata["from_date"]}</span>
              </p>
              <p className="cardText2 ">
                {" "}
                {bookingdata["mobile_no"]} , <span>{bookingdata["email"]}</span>{" "}
                , <span>Licence No : {bookingdata["driving_licence"]}</span>
              </p>
            </div>
          </div>
          <div className="Right_data">
            <button type="button" onClick={handleShowMainModal}>
              Add Maintenance
            </button>
          </div>
        </div>

        <div className="bottmData_maintance">
          <div className="row">
            <div className="col-md-6">
              {" "}
              <div className="paymentTable">
                <h4>Payments</h4>
                <table
                  className="table table-striped table-bordered"
                  style={{ borderRadius: "10px" }}
                >
                  <thead>
                    <tr>
                      <th>
                        <div className="tbl_heading">Sr. No.</div>
                      </th>
                      <th>
                        <div className="tbl_heading">Payment Date</div>
                      </th>
                      <th>
                        <div className="tbl_heading">Amount</div>
                      </th>
                      <th>
                        <div className="tbl_heading">Payment Mode </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {payment.map((payment, index) => (
                      <tr key={index}>
                        <td style={{ fontSize: "13px" }}>
                          <div className="tabl">{index + 1}</div>
                        </td>
                        <td style={{ fontSize: "13px" }}>
                          <div className="tabl">
                            {formatDateStringdot(payment.entry_date)}
                          </div>
                        </td>
                        <td style={{ fontSize: "13px" }}>
                          <div className="tabl">
                            {" "}
                            <FaRupeeSign />{" "}
                            {payment.ledger_price.toLocaleString()}
                          </div>
                        </td>
                        <td style={{ fontSize: "13px" }}>
                          <div className="tabl">{payment.payment_mode}</div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/**-------------------------maintance Table-------------------------- */}
            <div className="col-md-6">
              <div className="maintainaceTable">
                <h4>Maintenance Table</h4>
                <div className="upcoming_maintance">
                  <p>Upcomming Maintenance</p>
                  <p>Date: {bookingdata["next_maintenance_date"]}</p>
                </div>
                <table
                  className="table table-striped table-bordered"
                  style={{ borderRadius: "10px" }}
                >
                  <thead>
                    <tr>
                      <th>
                        <div className="tbl_heading">Sr. No.</div>
                      </th>
                      <th>
                        <div className="tbl_heading">Date</div>
                      </th>
                      <th>
                        <div className="tbl_heading">Done By</div>
                      </th>
                      <th>
                        <div className="tbl_heading">Status</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {mainbtanance.map((payment) => (
                      <tr key={payment.id}>
                        <td style={{ fontSize: "13px" }}>
                          <div className="tabl2">{payment.id}</div>
                        </td>
                        <td style={{ fontSize: "13px" }}>
                          <div className="tabl2">{payment.date}</div>
                        </td>
                        <td style={{ fontSize: "13px" }}>
                          <div className="tabl2">{payment.machenic}</div>
                        </td>
                        <td>
                          <div className="stats_maint">
                            <FaEye
                              style={{ cursor: "pointer", fontSize: "15px" }}
                              onClick={handleShowMainModal}
                            />
                            <select
                              className="form-select form-control "
                              id="default_order_type"
                              defaultValue="All"
                            >
                              <option value="All">All</option>
                              <option value="New">New</option>
                              <option value="InProgress">InProgress</option>
                              <option value="Ready For PickUp">
                                Ready For PickUp
                              </option>
                              <option value="Drop">Drop</option>
                              <option value="Completed">Completed</option>
                              <option value="Rejected">Rejected</option>
                            </select>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MaintenaceDataModal
        bookingdata={bookingdata}
        showUpcomingModal={showUpcomingModal}
        handleShowMainModal={handleShowMainModal}
      />
    </div>
  );
};

export default ViewMaintenance;
